import styled from "styled-components";

export const TipWrap = styled.div`
  min-width: 220px;
  padding: 10px;
  border-radius: 8px;
  background-color: #fff;
  box-sizing: border-box;
`;

export const TipContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const TipInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TipName = styled.div`
  color: #000;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TipSubName = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 18px;
  margin-top: 2px;
`;

export const TipPhone = styled.div`
  color: #8c8c8c;
  font-size: 12px;
  line-height: 18px;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
